import React from 'react'
import TabSearch from '../../NewComponent/TabSearch/tabSearch';
import SelectComp from '../../NewComponent/Select/Select';
import MultiSelect from '../../NewComponent/MultiSelect/MultiSelect';
import { useSelector, useDispatch } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Actions } from '../../Action';
import debounce from "lodash.debounce";
import { useCallback } from 'react';
export default function Filters() {
  const trendingState = useSelector(state=>state.trending);
    const [domain, setDdomain] = React.useState(trendingState.domains);
  const dispatch = useDispatch();
  const {trendingSearchQuery,trendingDataSelectDomains,trendingDataSelectSortingFilter,updateIsRelevanceTrendingData,isTrendingLoadMore} = bindActionCreators(Actions, dispatch);
  const trendingSortFilters = [
    {
      id: 1,
      value: "1",
      valueOrig: "questionAnswered",
      label: "Latest Answered",
      sortOrder: "desc",
    },
    {
      id: 2,
      value: "2",
      valueOrig: "questionAnswered",
      label: "Oldest Answered",
      sortOrder: "asc",
    },
    {
      id: 3,
      value: "3",
      valueOrig: "questionAsked",
      label: "Latest Asked",
      sortOrder: "desc",
    },
    {
      id: 4,
      value: "4",
      valueOrig: "questionAsked",
      label: "Oldest asked",
      sortOrder: "asc",
    },
    {
      id: 5,
      value: "5",
      valueOrig: "mostViewed",
      label: "Most Viewed",
      sortOrder: "desc",
    },
  ];

  const relevanceObj = {
    id: 6,
    value: "6",
    valueOrig: "revelance",
    label: "Relevance",
    sortOrder: "asc",
  };
  const onChangeFilter = (e)=>{
    isTrendingLoadMore([0, 0, 0, 0, 0, true]);
    let asdf = trendingSortFilters.filter(obj=>obj.value===e);
    trendingDataSelectSortingFilter(asdf[0])
  }
  const onChangeTabSearch = (e)=>{
    isTrendingLoadMore([0, 0, 0, 0, 0, true]);
    trendingSearchQuery(e.target.value);
    if(e.target.value.length !== 0){
      updateIsRelevanceTrendingData(true);
      if(!trendingState.isRelevence){
        trendingDataSelectSortingFilter(relevanceObj)
      }
    }else{
      updateIsRelevanceTrendingData(false)
    trendingDataSelectSortingFilter(trendingSortFilters[0]);
    }
  }
  const onChangeDomain = (e)=>{
    isTrendingLoadMore([0, 0, 0, 0, 0, true]);
     setDdomain(e);
    debouncedFetchOptions(e)
  }
  const userState = useSelector((state) => state.user);
  const updatesDomains = (arr) => {
    arr.filter(ar=>{
      ar.label = ar.name;
      ar.value = ar.name;
      return ar;
    })
    return arr;
  };
  const debouncedFetchOptions = useCallback(
      debounce((value) => trendingDataSelectDomains(value), 2000),
      []
    );
  return (
    <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',flexWrap:'wrap'}}>
      <div className='mt-1'>
        <TabSearch onChangeFunc={onChangeTabSearch} size={'large'} val={trendingState.searchQuery} />
      </div>
      <div className='mt-1' style={{display:'flex',justifyContent:'space-between',alignItems:'center'}}>
        <div><SelectComp width={'220px'} isString={false} val={trendingState.sortFilter} onChangeFunc={onChangeFilter} options={trendingState.searchQuery.length===0?trendingSortFilters:trendingSortFilters.concat([relevanceObj])} size={'large'} /></div>
        &nbsp;&nbsp;
        <div>
          <MultiSelect
          // width={'150px'}
            placeholder={'Select Domains'}
            size={'large'}
            onChangeFunc={onChangeDomain}
            options={updatesDomains(userState.expertTopics)}
            value={domain}
          />
        </div>
      </div>
    </div>
  )
}
